import { removeUser } from "../store/slices/userSlice";

export const tokenMiddleware = (store) => (next) => (action) => {
  const token = store.getState().user.token;

  if (token) {
    try {
      const tokenData = JSON.parse(atob(token.split(".")[1]));
      const expirationTime = tokenData.exp * 1000;
      const currentTime = Date.now();

      if (currentTime >= expirationTime) {
        store.dispatch(removeUser());
        return;
      }
    } catch (error) {
      console.error("Ошибка проверки токена:", error);
      store.dispatch(removeUser());
      return;
    }
  }

  return next(action);
};
